import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ScissorsIcon, SparklesIcon, CrownIcon, HeartIcon, StarIcon, GemIcon } from 'lucide-react';
const services = [{
  title: 'Knotless Braids',
  description: 'Pain-free, lightweight, and natural-looking braids that protect your edges and offer styling versatility from day one.',
  price: 'From $180',
  icon: CrownIcon,
  image: 'https://cdn.magicpatterns.com/uploads/vuTG195XiLqBgVUgSo55rG/istockphoto-1328500183-612x612.webp'
}, {
  title: 'Box Braids',
  description: 'Classic, timeless, and elegant. Our traditional box braids are crafted with precision for long-lasting wear.',
  price: 'From $150',
  icon: GemIcon,
  image: 'https://cdn.magicpatterns.com/uploads/4HrN3tu5KNpG8RhMYChL1b/istockphoto-1352674262-612x612.webp'
}, {
  title: 'Cornrows',
  description: 'Intricate, neat, and culturally rich designs. From simple straight backs to complex geometric patterns.',
  price: 'From $80',
  icon: ScissorsIcon,
  image: 'https://cdn.magicpatterns.com/uploads/oPcjCp9rNhyi11miaW2wZo/istockphoto-1618291225-612x612.webp'
}, {
  title: 'Goddess Braids',
  description: 'Thick, beautiful braids with curly ends or pieces left out for a romantic, bohemian aesthetic.',
  price: 'From $165',
  icon: SparklesIcon,
  image: 'https://cdn.magicpatterns.com/uploads/87rXMcBwVohMSGNCqWzK4j/istockphoto-1312551586-612x612.webp'
}, {
  title: 'Faux Locs',
  description: 'Get the beautiful look of traditional locs without the long-term commitment. Textured, natural, and stunning.',
  price: 'From $200',
  icon: StarIcon,
  image: 'https://cdn.magicpatterns.com/uploads/9HJ51oQBNvS7NQJc6RsA29/istockphoto-1370569973-2048x2048.jpg'
}, {
  title: 'Senegalese Twists',
  description: 'Smooth, sleek, and elegant two-strand twists that offer a sophisticated alternative to traditional braids.',
  price: 'From $160',
  icon: HeartIcon,
  image: 'https://cdn.magicpatterns.com/uploads/tGErXKv5tYnexYUuxYDfJC/side-view-image-of-beautiful-braid-hair.jpg'
}];
export function ServicesSection() {
  const navigate = useNavigate();
  return <section className="py-8 md:py-24 bg-cream relative" data-id="element-302">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303">
        <div className="text-center mb-10 md:mb-16" data-id="element-304">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading font-bold text-jet mb-4" data-id="element-305">
            Our Signature Services
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-burgundy mx-auto rounded-full" data-id="element-306"></motion.div>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mt-6 text-jet/60 max-w-2xl mx-auto text-lg" data-id="element-307">
            Expertly crafted styles tailored to enhance your natural beauty and
            protect your hair.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-308">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-sm border border-brown/10 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group overflow-hidden" data-id="element-309">
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden" data-id="element-310">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-311" />
                <div className="absolute inset-0 bg-gradient-to-t from-jet/60 to-transparent" data-id="element-312"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-beige/90 rounded-full flex items-center justify-center group-hover:bg-golden transition-colors duration-300" data-id="element-313">
                  <service.icon className="w-6 h-6 text-burgundy group-hover:text-jet transition-colors duration-300" data-id="element-314" />
                </div>
              </div>

              <div className="p-8" data-id="element-315">
                <h3 className="text-2xl font-heading font-bold text-jet mb-3" data-id="element-316">
                  {service.title}
                </h3>
                <p className="text-jet/60 mb-6 leading-relaxed min-h-[80px]" data-id="element-317">
                  {service.description}
                </p>
                <div className="flex items-center justify-between border-t border-gray-100 pt-4" data-id="element-318">
                  <span className="font-bold text-burgundy" data-id="element-319">
                    {service.price}
                  </span>
                  <button className="text-jet/70 font-medium hover:text-burgundy transition-colors text-sm uppercase tracking-wider" onClick={() => navigate('/booking')} data-id="element-320">
                    Book Now →
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}